import { type FeatureModule } from '@store/features/types';

import { componentRefreshMiddleware } from './componentRefreshMiddleware';

export const serverUiFeature: FeatureModule = {
  id: 'server-ui',
  name: 'Server UI',
  dependencies: [],
  reducers: {},
  middleware: [componentRefreshMiddleware.middleware],
};
